import React from "react"
import {
    Container,
    Col,
    Row} from 'reactstrap';
import controlmap from "./images/controlmap.png"
import Header from "./Header"
import aq from "./images/aq.png"
import base from "./images/base.png"
import houthi from "./images/houthi.png"
import hadi from "./images/hadimap.png"
import blank from "./images/blank.png"

import houthilabel from "./images/houthilabel.png"
import hadilabel from "./images/hadilabel.png"
import aqlabel from "./images/aqlabel.png"
import sparselabel from "./images/sparselabel.png"

class ControlMap extends React.Component{
    constructor(){
        super()
        this.state={
            layer1:false,
            layer2:false,
            layer3:false
        }
        this.Layer1 = this.Layer1.bind(this);
        this.Layer2 = this.Layer2.bind(this);
        this.Layer3 = this.Layer3.bind(this);
    }

        

        Layer1(){
            this.setState(prevState => {
            return {
                layer1: !prevState.layer1
            }
            })
        }
        Layer2(){
            this.setState(prevState => {
            return {
                layer2: !prevState.layer2
            }
            })
        }
        Layer3(){
            this.setState(prevState => {
            return {
                layer3: !prevState.layer3
            }
            })
        }

    render(){
        return(
            <div>
                <Header/>
                <br/>
                <br/>
                <Container>
                    <Row>
                        <Col xs="12" xl={{ size: 10, offset: 1 }}>
                        <h2 className="display-3 text-left">Who controls Yemen?</h2>

                    <div className="mapout">
                            <img className="mapin img-fluid" style={{opacity:this.state.layer1 ? 0: 1}} src={hadi}/>
                            <img className="mapin img-fluid" style={{opacity:this.state.layer2 ? 0: 1}} src={aq}/>
                            <img className="mapin img-fluid" style={{opacity:this.state.layer3 ? 0: 1}} src={houthi}/>
                            <img className="mapin img-fluid" src={base}/>

                    </div>
                    <img className="img-fluid" src={blank}/>
                    <Row>
                        <Col>
                            <p style={{lineHeight:"100%", color:"#f94f33"}}>Toggle the map layers:</p>
                            </Col>
                    </Row>
                        <Row>
                        <Col className="mapbutton" id="layer3" style={{opacity:this.state.layer3 ? 0.5: 1}} onClick={this.Layer3} xs="3">
                            <img className="img-fluid" src={houthilabel}/>
                        </Col>
                        <Col className="mapbutton" id="layer1" style={{opacity:this.state.layer1 ? 0.5: 1}} onClick={this.Layer1} xs="3">
                            <img className="img-fluid" src={hadilabel}/>
                        </Col>
                        <Col className="mapbutton" id="layer2" style={{opacity:this.state.layer2 ? 0.5: 1}} onClick={this.Layer2} xs="3">
                            <img className="img-fluid" src={aqlabel}/>
                        </Col>
                        <Col xs="3">
                            <img className="img-fluid" src={sparselabel}/>
                        </Col>
                        </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                        <br/>
                        <p>Four years after the launch of the Saudi-led campaign, the bulk of Yemen's northern highlands, as well as the capital city of Sanaa, remain under the control of Houthi rebels.</p>
<p>While Hodeidah, home to Yemen's largest port and the main gateway for food, fuel and humanitarian aid entering the country, has seen a lull in fighting since December after the implementation of a ceasefire agreement between the Yemeni government and Houthi rebels, the violence has continued unabated elsewhere.</p>
<p>In Taiz, Yemen's third-largest city, local militias backed by the United Arab Emirates have turned on each other since they expelled Houthi fighters from large sections of the city.</p>
<p>While Yemeni forces backed by the coalition have made notable gains in some areas bordering the kingdom, as well as in Nihm District in the Sanaa Governorate, some 50km east of the capital, more than 15 million Yemenis are still estimated to live under Houthi control.</p>
<p>President Abd-Rabbu Mansour Hadi and his prime minister, Maeen Abdulmalik Saeed, govern from the port city of Aden, but their government has failed to convene one session of parliament since the war erupted.</p>
<p>They have also failed to contend with a separatist movement in the south that has intensified its calls for an uprising against the internationally-recognised government.</p>
<p>The UAE-backed Southern Transitional Council (STC) has repeatedly undermined the government as it seeks to revive the former South Yemen republic which merged with the north in 1990.</p>
<p>At the same time, al-Qaeda in the Arabian Peninsula has continued to launch deadly attacks but appears to have shifted its priorities.</p>
<p>The armed group has lost large areas of territory it once controlled to UAE-backed militias, however it still operates training camps in some areas of the south and continues to take credit for attacks on Houthi-linked targets.</p>
<p>In July, one of al-Qaeda's senior leaders, Khaled Baterfi, said his group had reduced attacks against President Hadi and UAE-backed forces because assailing them would benefit the Houthis.</p>
<p>Also in the south, the Yemeni chapter of the Islamic State in Iraq and the Levant (ISIL or ISIS) has exploited the security vacuum and claimed responsibility for several attacks against al-Qaeda, Houthi fighters and pro-government troops.</p>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}
export default ControlMap